import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const TaskCollaborationPage = lazy(() => import('./pages/TaskCollaborationPage'));
const ProjectFilesPage = lazy(() => import('./pages/ProjectFilesPage'));
const ClientPortalPage = lazy(() => import('./pages/ClientPortalPage'));
const ProgressUpdatesPage = lazy(() => import('./pages/ProgressUpdatesPage'));
const MeetingNotesPage = lazy(() => import('./pages/MeetingNotesPage'));

export const CollaborationRoutes: RouteObject = {
  path: 'collaboration',
  handle: { crumb: 'Client & Team Collaboration' },
  element: <ModuleGuard moduleId="projects.collaboration" />,
  children: [
    { index: true, element: <Navigate to="task-collaboration" replace /> },
    { path: 'task-collaboration', element: <TaskCollaborationPage />, handle: { crumb: 'Task Collaboration' } },
    { path: 'project-files', element: <ProjectFilesPage />, handle: { crumb: 'Project Files' } },
    { path: 'client-portal', element: <ClientPortalPage />, handle: { crumb: 'Client Portal' } },
    { path: 'progress-updates', element: <ProgressUpdatesPage />, handle: { crumb: 'Progress Updates' } },
    { path: 'meeting-notes', element: <MeetingNotesPage />, handle: { crumb: 'Meeting Notes' } },
  ],
};
